import {
  ITennisLiveScore
} from "@sky-it-livedata/livedata-sports-design-system";
import { loggerFactory } from "@sky-it-livedata-libraries/livedata-commons";
import errors from "../../utils/errors";
import { LiveScoreSubscriptionData } from "./types";
import { intcmpMap } from "../../utils/intcmp";

const logger = loggerFactory();

const isValidObject = (obj: LiveScoreSubscriptionData) =>
  Boolean(obj?.data?.onUpdateLiveScoreById);

export const transformSubscription = (obj: LiveScoreSubscriptionData): ITennisLiveScore => {
  if (isValidObject(obj)) {
    try {
      const { liveTournaments } = obj?.data?.onUpdateLiveScoreById;

      return {
        liveTournaments,
        resultsIntcmp: intcmpMap.liveScoreAtpResults,
      } as ITennisLiveScore;
    } catch (error) {
      logger.error(
        "ERROR 6003: transform() error in Live Score subscription transformer",
        obj
      );
      throw errors.fromCode(6003);
    }
  } else {
    logger.error("ERROR 6002", obj);
    throw errors.fromCode(6002);
  }
};